export default {
  regiolux: {
    showDebugDrawer: "Show Debug Drawer",
    "previous.configuration": "Zurück",
    "next.configuration": "Weiter",
    "reset.configuration": "Auswahl zurücksetzen",
    "reset.subConfiguration": "Gruppe zurücksetzen",
    "bom.header": "Stückliste",
    "bom.sum": "Summe Positionen",
    "add.XAS_GERAETETRAEGER": "Geräteträger hinzufügen",
    "add.XAS_FUNKTIONSMODUL": "Funktionsmodul hinzufügen (Optional)",
    "add.XAS_TRAGSCHIENE": "Tragschiene, Montageart und Blindabdeckung",
    "add.show_BOM": "Konfigurationsergebnis anzeigen",
    addToShoppingCart: "Zum Sammelkorb hinzufügen",
    saveConfiguration: "Konfiguration speichern",
    "sidebar.header": "SRT KONFIGURATOR",
    "dialog.requestQuote.open": "Angebot anfragen",
    "dialog.requestQuote.geolocationDE.specialistRetailerText":
      "Bitte nennen Sie uns Ihren Fachhandel, von dem Sie das Angebot erhalten möchten:",
    "dialog.requestQuote.geolocationDE.specialistRetailerName": "Fachhandel",
    "dialog.requestQuote.geolocationDE.specialistRetailerLocation": "Ort",
    "dialog.requestQuote.geolocationDE.specialistRetailerContact":
      "Ansprechpartner",
    "dialog.requestQuote.geolocationDE.specialistRetailerCustomerNo":
      "Kundennummer Fachhandel (falls vorhanden)",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerText":
      "Bitte geben Sie uns Ihren bevorzugten Vertriebspartner an:",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerName":
      "Vertriebspartner",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerLocation":
      "Ort",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerContact":
      "Ansprechpartner",
    "dialog.requestQuote.geolocationDifferent.specialistRetailerCustomerNo":
      "Kundennummer Vertriebspartner (falls vorhanden)",
    "dialog.requestQuote.message": "Nachricht",
    "dialog.requestQuote.email": "Ihre E-Mail-Adresse",
    "dialog.requestQuote.title": "Anrede",
    "dialog.requestQuote.firstName": "Vorname",
    "dialog.requestQuote.lastName": "Nachname",
    "dialog.requestQuote.phoneNumber": "Telefonnummer",
    "dialog.requestQuote.optionalDetails": "freiwillige Angaben",
    "dialog.requestQuote.street": "Straße / Nr.",
    "dialog.requestQuote.postcode": "Ort / PLZ",
    "dialog.requestQuote.company": "Firma",
    "dialog.requestQuote.position": "Position",
    "dialog.requestQuote.industry": "Branche",
    "dialog.requestQuote.country": "Land",
    "dialog.requestQuote.mobileNumber": "Mobil",
    "dialog.requestQuote.text.title": "Sammelkorb",
    "dialog.requestQuote.description": "Bitte füllen Sie das Formular aus",
    "dialog.requestQuote.text.cancel": "Zurück",
    "dialog.requestQuote.text.confirm": "Angebot anfragen",
    "dialog.requestQuote.dataPrivacy.title": "Datenschutz",
    "dialog.requestQuote.dataPrivacy.text.start":
      "Mit der Anfrage erkläre ich mich mit der Speicherung und Nutzung der Daten gemäß der",
    "dialog.requestQuote.dataPrivacy.text.end":
      "der Firma Regiolux GmbH einverstanden.",
    "dialog.requestQuote.dataPrivacy.link.text": "Datenschutzerklärung",
    "dialog.requestQuote.dataPrivacy.link.url":
      "https://www.regiolux.de/de/datenschutz",
    "dialog.requestQuote.emailMarketingConsent.title": "Information",
    "dialog.requestQuote.text.tooltip":
      "Bitte Projektbezeichnung und Projektort ausfüllen.",
    "tooltip.toConfigure": "Konfigurieren",
    "title.configurationFinished":
      "Die Konfiguration wurde erfolgreich abgeschlossen.",
    "subItem.property.label.listPrice": "Listenpreis",
    "subItem.property.label.totalList": "Summe",
    "item.property.label.totalList": "Summe",
    "toast.requestQuote.error": "Angebot konnte nicht angefragt werden",
    "additionalQuoteFields.textBlock":
      "Der Sammelkorb ist zur Angebotserstellung für gewerbliche Kunden über den Fachhandel eingerichtet.\nIhre Zusammenstellung leiten wir an Ihren Fachhandelspartner zur Angebotserstellung weiter.\nIm Bereich „Angebot anfragen“ ist dann die Angabe Ihres Fachhandelspartners notwendig.",
    "label.additionalQuoteFields.projectDescription": "Projektbezeichnung",
    "label.additionalQuoteFields.projectLocation": "Projektort",
    "item.property.label.note": "Hinweis",
    "button.downloadShoppingCart.label": "Sammelkorb herunterladen",
    "button.finishConfiguration.label": "Konfiguration abschließen",
    "button.showBOM.label": "Konfigurationsergebnis anzeigen",
    "button.showBOM.disabledTooltip": "Konfiguration ist unvollständig",
    "tooltip.configurationIncomplete": "Konfiguration ist unvollständig",
    "tooltip.noUserSessionId": "Keine gültige Benutzersitzung gefunden",
  },
  CPQ: {
    "cart.title": "Sammelkorb",
    "cart.label.emptyCart": "Ihr Sammelkorb ist leer.",
  },
};
